import { call, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  fetchReportsSuccess,
  fetchReportsFailure,
  FetchReportsRequestAction,
} from './actions';
import { getReportsData } from '../../api/api';

export function* fetchReportsSaga(action: FetchReportsRequestAction) {
  const { factories, columns, month, year, subdivisions, group } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(getReportsData, { factories, columns, month, year, subdivisions, group });
    yield put(fetchReportsSuccess(response.data));
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Ошибка при загрузке отчетов';
    console.error('Ошибка при загрузке отчетов:', error);
    yield put(fetchReportsFailure(errorMessage));
  }
}
